import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../config/constants";

export const useAppNavigation = () => {
    const navigate = useNavigate();

    const goToLoginAndReplace = () => {
        navigate(APP_ROUTES.LOGIN, { replace: true });
    };

    const goToPath = (path: string) => {
        navigate(path);
    };

    const goToDashboard = () => navigate(APP_ROUTES.DASHBOARD);

    return {
        goToLoginAndReplace,
        goToPath,
        goToDashboard,
    };
};